<template>
  <v-text-field
    v-bind="$attrs"
    :value="value"
    :label="label"
    :disabled="disabled"
    :required="required"
    :rules="dateRules"
    type="text"
    placeholder="DD.MM.YYYY"
    autocomplete="off"
    @input="$emit('input', $event || '')"
    @blur="trimValue"
  >
    <template v-slot:append>
      <v-menu
        v-model="calendarOpen"
        :close-on-content-click="false"
        :disabled="disabled"
        offset-y
        min-width="290px"
        max-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            small
            type="button"
            :disabled="disabled"
            :aria-label="'Choose date: ' + label"
          >
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </template>
        <v-date-picker
          :value="calendarValue"
          :min="min || undefined"
          :disabled="disabled"
          :first-day-of-week="1"
          @input="selectDate"
        />
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import { formatDate, parseDate } from "../utils/dates.js";

export default {
  name: "DateInput",
  inheritAttrs: false,
  props: {
    // Keep the raw text in v-model, including incomplete or invalid input.
    // The enclosing v-form validates it before conversion to an API date.
    value: { type: String, default: "" },
    label: { type: String, default: "Date" },
    required: Boolean,
    disabled: Boolean,
    // Calendar bounds use the same ISO format as v-date-picker.
    min: { type: String, default: null }
  },
  data: () => ({ calendarOpen: false }),
  computed: {
    calendarValue() {
      return parseDate(this.value);
    },
    dateRules() {
      return [
        value => {
          if (!(value || "").trim()) return this.required ? "Required." : true;
          const date = parseDate(value);
          if (!date) return "Enter a valid date as DD.MM.YYYY.";
          if (this.min && date < this.min) {
            return "Date must be on or after " + formatDate(this.min) + ".";
          }
          return true;
        }
      ];
    }
  },
  methods: {
    trimValue() {
      this.$emit("input", (this.value || "").trim());
    },
    selectDate(value) {
      this.$emit("input", formatDate(value));
      this.calendarOpen = false;
    }
  }
};
</script>
